import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Forms',
  },
  {
    path: 'Search',
    breadcrumbName: 'Search',
  },
];

const Search = () => {
  return (
    <>

      <PageHeader title="Search" breadcrumb={{ routes }} subTitle="Search-bar" style={{ padding: 10 }} />

      <div className="MF_area">
        <form class="search_bar_default_wrapper">
          <input type="text" id="search_form" placeholder="Search" />
          <button type="submit" class="search_btn">Search start!</button>
        </form>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<form class="search_bar_default_wrapper">
  <input type="text" id="search_form" placeholder="Search" />
  <button type="submit" class="search_btn">Search start!</button>
</form>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>



      <PageHeader title="Search" breadcrumb={{ routes }} subTitle="Search bar-darkblue" style={{ padding: 10 }} />

      <div className="MF_area">
        <form class="search_bar_default_wrapper">
          <input type="text" id="search_form" placeholder="Search" />
          <button type="submit" class="search_btn darkblue">Search start!</button>
        </form>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<form class="search_bar_default_wrapper">
  <input type="text" id="search_form" placeholder="Search" />
  <button type="submit" class="search_btn darkblue">Search start!</button>
</form>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>



      <PageHeader title="Search" breadcrumb={{ routes }} subTitle="Search bar - big" style={{ padding: 10 }} />

      <div className="MF_area">
        <div class="search_bar_big_wrapper">
          <input type="text" />
          <button type="submit">
            <span class="icon_search"></span>
          </button>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="search_bar_big_wrapper">
  <input type="text">
  <button type="submit">
      <span class="icon_search"></span>
  </button>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default Search;